"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var FocusOnInitDirective = (function () {
    function FocusOnInitDirective(element) {
        this.element = element;
    }
    FocusOnInitDirective.prototype.ngAfterViewInit = function () {
        this.element.nativeElement.focus();
    };
    return FocusOnInitDirective;
}());
FocusOnInitDirective = __decorate([
    core_1.Directive({
        selector: '[focusOnInit]'
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], FocusOnInitDirective);
exports.FocusOnInitDirective = FocusOnInitDirective;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/custom-directives/focus-on-init.directive.js